<template>
  <section class="full-loading" :class="{ absolute, [theme]: !!theme }" :style="[background ? `background-color: ${background}` : '']" v-show="loading">
    <div class="full-loading__content">
      <BrandLoadingMark :size="markSize" :show-text="showTip" :text="tip" />
    </div>
  </section>
</template>
<script lang="ts">
  import { PropType } from 'vue';
  import { defineComponent } from 'vue';
  import { SizeEnum } from '/@/enums/sizeEnum';
  import BrandLoadingMark from './BrandLoadingMark.vue';

  export default defineComponent({
    name: 'Loading',
    components: { BrandLoadingMark },
    props: {
      tip: {
        type: String as PropType<string>,
        default: '',
      },
      size: {
        type: String as PropType<SizeEnum>,
        default: SizeEnum.LARGE,
        validator: (v: SizeEnum): boolean => {
          return [SizeEnum.DEFAULT, SizeEnum.SMALL, SizeEnum.LARGE].includes(v);
        },
      },
      absolute: {
        type: Boolean as PropType<boolean>,
        default: false,
      },
      loading: {
        type: Boolean as PropType<boolean>,
        default: false,
      },
      background: {
        type: String as PropType<string>,
      },
      theme: {
        type: String as PropType<'dark' | 'light'>,
      },
    },
    computed: {
      markSize(): 'small' | 'large' {
        return this.size === SizeEnum.SMALL ? 'small' : 'large';
      },
      showTip(): boolean {
        return !!this.tip;
      },
    },
  });
</script>
<style lang="less" scoped>
  .full-loading {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2000;
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    background-color: rgba(240, 242, 245, 0.4);

    &__content {
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    &.absolute {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 300;
    }
  }

  html[data-theme='dark'] {
    .full-loading:not(.light) {
      background-color: @modal-mask-bg;
    }
  }

  .full-loading.dark {
    background-color: @modal-mask-bg;
  }
</style>
